<div class="container">
	<div class="video">
		<h1 class="video__header">
			What makes Cloudstaff the best workplace anywhere?
		</h1>
		<div class="video__content">
			<iframe
				width="560"
				height="415"
				src="https://www.youtube.com/embed/WfEwTtRkNRA"
				title="YouTube video player"
				allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
				referrerpolicy="strict-origin-when-cross-origin"
				allowfullscreen
			></iframe>
		</div>
	</div>
</div>
